<template>
  <div class="main">
    <div class="banner">
        <div class="title">在线气象证明</div>
        <div class="tip" @click ="goApply">
          点击进入办理
          <img src="/static/image/weatherCertificate/right_arrow.png" />
        </div>
    </div>
    <MyCertificate></MyCertificate>


  </div>

</template>
<script>
import MyCertificate from './MyCertificate.vue'
import Vue from "vue";
export default Vue.extend({
  components: {
      MyCertificate
    },
  data() {
    return {
      data: {},
    }
  },
  methods:{
    goApply(){
      this.$router.push('/weather_certificate/apply')
    }
  }
})
</script>

<style scoped lang="scss">
.main {
  height: 100vh;
  width: 100vw;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.banner{
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
  text-align: start;
  width: 100vw;
  height: 124px;
  background: url(/static/image/weatherCertificate/bg.png) no-repeat;
  background-size: 100vw 124px;
  background-position:center center;
  color: #FFFFFF;
  .title{
    margin-left: 50px;
    text-align: start;
    font-size: 24px;
    font-weight: 600;
    line-height: 33px;
  }
  .tip{
    margin-left: 50px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
}


</style>
